// extracted by mini-css-extract-plugin
export default {"error_not_found":"Error_error_not_found__ahmBn","link_to_home":"Error_link_to_home__21oyu"};